export default (theme) => ({
  illustration: {
    backgroundColor: theme.palette.skeleton.image,
    width: '100%',
    height: 'auto',
    display: 'block',
    margin: 0,
    padding: 0,
    paddingBottom: '56.25%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  defaultIllustration: {},
});
